import { Carousel } from '@mantine/carousel'
import {
	Anchor,
	Avatar,
	Badge,
	Box,
	Button,
	Card,
	em,
	Flex,
	Group,
	Image,
	Loader,
	Paper,
	Rating,
	rem,
	Text,
	Title,
} from '@mantine/core'
import { useMediaQuery } from '@mantine/hooks'
import { IconArrowLeft, IconArrowRight, IconMapPin } from '@tabler/icons-react'
import { Fragment, useEffect } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import fallbackImage from '../../assets/Placholder-01.png'
import FoodItemCard from '../../components/FoodItemCard.tsx'
import Colors from '../../constants/colors.ts'
import { getOneRestaurantAction } from '../../store/restaurants/restaurantsActions.ts'
import { useAppDispatch, useAppSelector } from '../../store/store.ts'
import { calculateRatings } from '../../utils/ratingCalculator.ts'
import classes from '../buyer/home/carousel.module.css'

const SellerFoodShop = () => {
	const isMobile = useMediaQuery(`(max-width: ${em(768)})`)
	const location = useLocation()
	const { id } = useParams()
	const dispatch = useAppDispatch()
	const { singleRestaurant, loaders } = useAppSelector(
		(state) => state.restaurants
	)
	const navigate = useNavigate()
	// const foodTags = [
	// 	'Starter',
	// 	'Main Course',
	// 	'Desert',
	// 	'Beverage',
	// 	'Soup And Salad',
	// 	'Fast Food',
	// 	'Snacks',
	// 	'Other',
	// ]

	useEffect(() => {
		if (!id) return
		dispatch(getOneRestaurantAction({ id: id }))
		// dispatch(getRecentSearchesAction('food'))
		window.scrollTo({ top: 0, behavior: 'smooth' })
	}, [dispatch, id])

	return (
		<>
			{loaders.gettingFoodsOfRestaurant ? (
				<Flex h='100vh' w='100vw' justify='center' align='center'>
					<Loader />
				</Flex>
			) : (
				<Flex direction='column' mb='lg' justify='center' align='center'>
					<Card
						m={isMobile ? '' : 'sm'}
						radius='lg'
						w={isMobile ? '100%' : '80%'}
					>
						<Flex
							justify='space-between'
							align={isMobile ? 'center' : ''}
							direction={isMobile ? 'column' : 'row'}
							w='100%'
						>
							<Flex
								direction={isMobile ? 'column' : 'column'}
								w='100%'
								align={isMobile ? 'center' : ''}
								gap={isMobile ? '' : 'xl'}
							>
								<Card
									p={0}
									radius='md'
									padding='sm'
									bg={Colors.grayBackground}
									h={'max-content'}
								>
									<Box>
										<Image
											radius='lg'
											src={
												singleRestaurant?.restaurant?.restaurantDetails?.image
											}
											height={300}
											alt='Banner'
											style={{ objectFit: 'cover' }}
											fallbackSrc={fallbackImage}
										/>
									</Box>
									<Flex
										justify='space-between'
										align={isMobile ? 'start' : 'center'}
										mb='sm'
										direction={isMobile ? 'column' : 'row'}
									>
										<Flex
											direction={'column'}
											align={'start'}
											gap={'xs'}
											m={'lg'}
										>
											<Avatar
												src={
													singleRestaurant?.restaurant?.restaurantDetails?.image
												}
												radius='100%'
												size='xl'
												styles={{
													root: { marginTop: -40, border: '2px solid white' },
												}}
											/>
											<Box>
												<Title order={3}>
													{
														singleRestaurant?.restaurant?.restaurantDetails
															?.title
													}
												</Title>
												<Text size='sm' c='dimmed'>
													{
														singleRestaurant?.restaurant?.restaurantDetails
															?.description
													}
												</Text>
												<Badge color='green' size='md' variant='light' mt={4}>
													{
														singleRestaurant?.restaurant?.restaurantDetails
															?.verificationStatus
													}
												</Badge>
											</Box>
											<Flex>
												<IconMapPin
													style={{
														marginRight: 10,
														marginTop: 3,
														color: '#767C8C',
													}}
													size={20}
												/>
												<Text style={{ color: '#767C8C' }}>
													{
														singleRestaurant?.restaurant?.restaurantDetails
															?.address?.formattedAddress
													}
												</Text>
											</Flex>
										</Flex>
										<Flex direction='column' mx='lg'>
											<Flex my='lg' gap='sm' align='center' w='100%'>
												<Rating
													value={calculateRatings(
														singleRestaurant?.restaurant?.restaurantDetails
															?.rating?.totalRating,
														singleRestaurant?.restaurant?.restaurantDetails
															?.rating?.numRating
													)}
													readOnly
												/>
												{singleRestaurant?.restaurant?.restaurantDetails?.rating
													?.totalRating && (
													<Text c='#A8AEBF'>
														(
														{
															singleRestaurant?.restaurant?.restaurantDetails
																?.rating?.totalRating
														}
														+ ratings)
													</Text>
												)}
												{/*<Text>3.10 miles away</Text>*/}
											</Flex>
											<Flex gap='lg' justify={isMobile ? 'space-evenly' : ''}>
												<Button
													variant={isMobile ? 'outline' : ''}
													size={isMobile ? 'lg' : 'md'}
													fw={400}
													radius='xl'
													color='#62BE12'
													onClick={() => {
														navigate(
															`/chat/${singleRestaurant?.restaurant?.restaurantDetails?.userId}?name=${singleRestaurant?.restaurant?.restaurantDetails?.title}&avatar=${singleRestaurant?.restaurant?.restaurantDetails?.image}`
														)
													}}
												>
													Message
												</Button>
											</Flex>
										</Flex>
									</Flex>
								</Card>

								{/* Contact Details */}
								<Paper radius='md' p='md' my='md' bg={Colors.grayBackground}>
									<Group mb='xs'>
										<Box>
											<Text size='sm' color='dimmed'>
												Email address
											</Text>
											<Text>
												{
													singleRestaurant?.restaurant?.restaurantDetails
														?.userId?.credentialDetails?.email
												}
											</Text>
										</Box>
										<Box>
											<Text size='sm' color='dimmed'>
												Contact
											</Text>
											<Text>
												{
													singleRestaurant?.restaurant?.restaurantDetails
														?.userId?.personalInformation?.phoneNumber
												}
											</Text>
										</Box>
									</Group>

									<Group>
										<Box>
											<Text size='sm' c='dimmed'>
												Registration No
											</Text>
											<Text>
												{
													singleRestaurant?.restaurant?.restaurantDetails
														?.registrationNumber
												}
											</Text>
										</Box>
										<Box>
											<Text size='sm' color='dimmed'>
												Category
											</Text>
											<Text>
												{
													singleRestaurant?.restaurant?.restaurantDetails
														?.category
												}
											</Text>
										</Box>
									</Group>
								</Paper>
							</Flex>
							<Group></Group>
						</Flex>
						<Flex
							direction='column'
							mb='lg'
							w='100%'
							justify='center'
							align='center'
						>
							<Flex w={'100%'} direction='column'>
								{singleRestaurant?.restaurant?.food?.length > 0 && (
									<Fragment>
										<Flex justify='space-between' mx={isMobile ? 'sm' : ''}>
											<Text fw={700}>Latest Products</Text>
											<Anchor
												style={{ color: '#62BE12' }}
												onClick={() => {
													if (location?.state?.user === 'guest') {
														navigate(`/view-all-foods/${id}`, {
															state: 'viewAll',
														})
													} else {
														navigate(`/buyer-view-all-foods/${id}`, {
															state: 'viewAll',
														})
													}
												}}
											>
												View all
											</Anchor>
										</Flex>

										<Carousel
											nextControlIcon={
												<IconArrowRight
													style={{
														width: rem(30),
														height: rem(30),
														boxShadow: '5px 5px 10px 2px rgba(0,0,0,.4)',
														borderRadius: '100px',
													}}
												/>
											}
											previousControlIcon={
												<IconArrowLeft
													style={{
														width: rem(30),
														height: rem(30),
														boxShadow: '5px 5px 10px 2px rgba(0,0,0,.4)',
														borderRadius: '100px',
													}}
												/>
											}
											slideSize={isMobile ? '150px' : '150px'}
											slideGap='xs'
											align='start'
											p='xs'
											dragFree
											classNames={classes}
										>
											{singleRestaurant?.restaurant?.food?.map(
												(food, index) => (
													<Carousel.Slide key={index}>
														<FoodItemCard
															user={location?.state?.user}
															food={food}
															key={index}
														/>
													</Carousel.Slide>
												)
											)}
										</Carousel>
									</Fragment>
								)}
							</Flex>
						</Flex>
						<Flex direction={'column'} mb='lg' w='100%'>
							<Title order={3} mb={10}>
								Reviews
							</Title>
							<Carousel align={'start'} withControls={false} slideSize={'30%'}>
								{singleRestaurant?.restaurant?.reviews?.length > 0 && (
									<>
										{singleRestaurant?.restaurant?.reviews?.map(
											(review, index) => {
												return (
													<Carousel.Slide key={index} >
														<div>
															<Group>
																<Avatar
																	src={
																		review?.user?.personalInformation
																			?.profilePic
																	}
																	alt=''
																	radius='xl'
																/>
																<div>
																	<Text size='sm'>
																		{
																			review?.user?.personalInformation
																				?.firstName
																		}
																	</Text>
																	<Text size='xs' c='dimmed'>
																		10 minutes ago
																	</Text>
																</div>
															</Group>
															<Text pl={54} pt='sm' size='sm'>
																{review?.review}
															</Text>
														</div>
													</Carousel.Slide>
												)
											}
										)}
									</>
								)}
							</Carousel>
						</Flex>
					</Card>
				</Flex>
			)}
		</>
	)
}

export default SellerFoodShop
